import React from 'react';
import { usePageMeta } from '../../../hooks/usePageMeta';
import Header from '../../../components/2025/Header';
import Footer from '../../../components/2025/Footer';
import FloatingNav from '../../../components/2025/FloatingNav';
import HeroTitle from '../../../components/2025/HeroTitle';
import { Chip } from '../../../components/2025/Chip';
import styles from './styles.module.scss';
import Button from '../../../components/2025/Button';

const Access2025: React.FC = () => {
  usePageMeta({
    title: 'アクセス',
    description:
      'かまた祭2025の会場アクセス情報。日本工学院専門学校・東京工科大学蒲田キャンパスへの交通案内、最寄り駅からのルート、注意事項などをご案内します。',
  });

  return (
    <div className={styles.accessContainer}>
      <Header />
      <HeroTitle title="ACCESS" subtitle="アクセス" />

      <div className={styles.access}>
        {/* Background decorations - same as blog detail */}
        <svg
          className={styles.decorationSvg}
          width="65"
          height="83"
          viewBox="0 0 65 83"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="15.5556" cy="25.2778" r="15.5556" fill="#F6B8DF" />
          <circle cx="41.5279" cy="49.3056" r="32.2222" stroke="#F6B8DF" strokeWidth="2.5" />
          <circle cx="41.5278" cy="6.52784" r="6.52778" fill="white" />
        </svg>

        <svg
          className={styles.decorationSvg2}
          width="81"
          height="86"
          viewBox="0 0 81 86"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect
            x="-58"
            y="72.6886"
            width="152.577"
            height="18.2606"
            rx="9.1303"
            transform="rotate(-29.7401 -58 72.6886)"
            fill="url(#paint0_linear_2467_1083)"
          />
          <defs>
            <linearGradient
              id="paint0_linear_2467_1083"
              x1="-58"
              y1="81.8189"
              x2="94.5775"
              y2="81.8189"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#0946F1" />
              <stop offset="1" stopColor="#F1ECE6" />
            </linearGradient>
          </defs>
        </svg>

        <svg
          className={styles.decorationSvg3}
          width="50"
          height="86"
          viewBox="0 0 50 86"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect
            x="-89"
            y="72.6886"
            width="152.577"
            height="18.2606"
            rx="9.1303"
            transform="rotate(-29.7401 -89 72.6886)"
            fill="url(#paint0_linear_2467_1081)"
          />
          <defs>
            <linearGradient
              id="paint0_linear_2467_1081"
              x1="-89"
              y1="81.8189"
              x2="63.5775"
              y2="81.8189"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#7B8DF2" />
              <stop offset="1" stopColor="#F6B8DF" />
            </linearGradient>
          </defs>
        </svg>

        <svg
          className={styles.decorationSvg4}
          width="120"
          height="141"
          viewBox="0 0 120 141"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="49.6515" cy="70.5972" r="69.7208" fill="#F6B8DF" />
        </svg>

        <svg
          className={styles.decorationSvg5}
          width="86"
          height="181"
          viewBox="0 0 86 181"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect
            x="-4.08789"
            y="166.771"
            width="299.576"
            height="22.2721"
            rx="11.1361"
            transform="rotate(-34.6137 -4.08789 166.771)"
            fill="url(#paint0_linear_2467_1087)"
            fillOpacity="0.5"
          />
          <defs>
            <linearGradient
              id="paint0_linear_2467_1087"
              x1="-4.08789"
              y1="177.907"
              x2="295.488"
              y2="177.907"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#4D83FE" />
              <stop offset="1" stopColor="#003078" />
            </linearGradient>
          </defs>
        </svg>

        <svg
          className={styles.decorationSvg6}
          width="41"
          height="41"
          viewBox="0 0 41 41"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M28.8162 0.995938C29.858 0.0372442 31.518 0.9718 31.2386 2.35977L28.8438 14.2587C28.7189 14.8795 29.0078 15.51 29.5596 15.8207L40.1361 21.7753C41.3698 22.4699 40.994 24.3374 39.5876 24.5006L27.531 25.8999C26.902 25.9729 26.3916 26.4426 26.2667 27.0633L23.8718 38.9623C23.5925 40.3503 21.7003 40.5699 21.1104 39.2828L16.0538 28.2487C15.7901 27.6731 15.1856 27.3328 14.5567 27.4058L2.50005 28.8052C1.09369 28.9684 0.300086 27.2366 1.34191 26.2779L10.2734 18.0591C10.7393 17.6304 10.8762 16.9504 10.6124 16.3748L5.55584 5.34065C4.96601 4.05356 6.36778 2.76365 7.60149 3.45823L18.178 9.41285C18.7298 9.72347 19.4188 9.6435 19.8847 9.21476L28.8162 0.995938Z"
            fill="#F6B8DF"
          />
        </svg>

        <svg
          className={styles.decorationSvg7}
          width="375"
          height="482"
          viewBox="0 0 375 482"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect
            x="-149.442"
            y="457.165"
            width="853.012"
            height="37.8276"
            rx="18.9138"
            transform="rotate(-32.9591 -149.442 457.165)"
            fill="url(#paint0_linear_2467_1075)"
            fillOpacity="0.5"
          />
          <defs>
            <linearGradient
              id="paint0_linear_2467_1075"
              x1="-149.442"
              y1="476.078"
              x2="703.569"
              y2="476.078"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#0007D2" />
              <stop offset="1" stopColor="white" />
            </linearGradient>
          </defs>
        </svg>

        <div className={styles.container}>
          <article className={styles.article}>
            <section className={styles.carSection}>
              <h2 className={styles.carSection__title}>お車でのご来場について</h2>
              <div className={styles.carSection__divider} />
              <div className={styles.carSection__content}>
                <p>
                  会場に専用駐車場はございません。
                  <br />
                  一部の参加者による会場の周辺施設への無断駐車・迷惑駐車によって、地域近隣住民の皆さまにご迷惑をおかけしています。車での来場および無断駐車・迷惑駐車が発覚した場合は、強制的に退場いただくか入場をお断りする場合がございます。
                  <br />
                  会場の周辺施設への無断駐車・迷惑駐車は絶対にお止めいただき、公共交通機関をご利用ください。
                </p>
              </div>
            </section>

            <section className={styles.campusSection}>
              <div className={styles.campusSection__header}>
                <Chip text="会場" variant="secondary" />
              </div>
              <h2 className={styles.campusSection__title}>蒲田キャンパス</h2>
              <p className={styles.campusSection__subtitle}>東京工科大学・日本工学院専門学校</p>

              <div className={styles.campusSection__mapPlaceholder}>
                <img src="/images/2025/map.jpg" alt="蒲田キャンパスマップ" />
              </div>

              <div className={styles.trainSection__info}>
                <p className={styles.trainSection__info__bt}>
                  JR京浜東北線・東急多摩川線・東急池上線
                  <br />
                  「蒲田駅」西口徒歩2分
                  <br />
                  京浜急行線「京急蒲田駅」徒歩15分
                </p>
              </div>
              <div className={styles.button}>
                <Button
                  title="Googleマップで見る"
                  href="https://www.google.com/maps/place/%E6%9D%B1%E4%BA%AC%E5%B7%A5%E7%A7%91%E5%A4%A7%E5%AD%A6+%E8%92%B2%E7%94%B0%E3%82%AD%E3%83%A3%E3%83%B3%E3%83%91%E3%82%B9/@35.5645439,139.715753,16z/data=!3m1!4b1!4m6!3m5!1s0x6018605cca9b0b8f:0x294e9fe055effe39!8m2!3d35.5645439!4d139.715753!16s%2Fg%2F1tdx_w4y?entry=ttu&g_ep=EgoyMDI1MTAxNC4wIKXMDSoASAFQAw%3D%3D"
                />
              </div>
            </section>
          </article>
        </div>
      </div>

      <Footer />
      <FloatingNav />
    </div>
  );
};

export default Access2025;
